import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import styles from './index.module.scss'
import API, { commonApiInvoker } from '@api/api'
import { Button, Divider, Empty, Image, Input, message, Select, Space, Spin, Checkbox, Radio } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import Utils from "@utils/utils"
import eventBus from '@utils/eventBus';
import { useLocation, useNavigate } from 'react-router-dom'
import { flushSync } from 'react-dom'
import PSAIModal from "@PSAIComponents/PSAIModal";
import JSZip from 'jszip'
import { saveAs } from "file-saver";
import DeliveryDetail from "./components/DeliveryDetail";
import { AppContext } from '@utils/AppContext';
import { downloadAsZip } from './DownloadFunc'
import { downloadWhitelist } from '@/utils/CONST'

const _ = require('lodash')

export default function MasterDelivery() {
    const { globalUser } = useContext(AppContext)
    const refs1 = useRef([])
    const refs2 = useRef([])
    const location = useLocation()
    const navigate = useNavigate()
    const [versionText, setVersionText] = useState()
    const [processVersionList, setProcessVersionList] = useState([]) // 进行中
    const [completedVersionList, setCompletedVersionList] = useState([]) // 已完成
    const [displayProcessVersionList, setDisplayProcessVersionList] = useState([])
    const [displayCompletedVersionList, setDisplayCompletedVersionList] = useState([])
    const initRef = useRef(false)

    const [loading, setLoading] = useState(false)
    const updateAndscrollIntoView = useCallback(_.debounce((version, list1, list2, block="nearest") => {
        // 使用 requestAnimationFrame 确保在下一帧执行
        requestAnimationFrame(() => {
            // 确保 DOM 立即更新
            flushSync(() => {
                setDisplayProcessVersionList(list1)
                setDisplayCompletedVersionList(list2)
            })
            if (version) {
                setVersionText(version)
                navigate(`/home/homemain/masterDeliver?${new URLSearchParams({version: version}).toString()}`)
                if (list1.includes(version)) {
                    refs1.current[list1.indexOf(version)]?.scrollIntoView({
                        behavior: 'smooth',
                        block: block,
                    })
                } else if (list2.includes(version)) {
                    refs2.current[list2.indexOf(version)]?.scrollIntoView({
                        behavior: 'smooth',
                        block: block,
                    })
                }
            } else {
                setVersionText()
                navigate(`/home/homemain/masterDeliver`)
            }
            initRef.current = true
        })
    }, 300), [])
    useEffect(() => {
        const params = new URLSearchParams()
        setLoading(true)
        commonApiInvoker(API.merchantversionList(params), false, true).then(res => {
            const processVersionList = (res || []).filter(item => item.status === 0).map(item => item.deliveryVersion)
            const completedVersionList = (res || []).filter(item => item.status === 1).map(item => item.deliveryVersion)
            setProcessVersionList(processVersionList)
            setCompletedVersionList(completedVersionList)
            
            const searchParams = new URLSearchParams(location.search)
            const searchVersion = searchParams.get('version')
            const version = searchVersion ||
                [...processVersionList, ...completedVersionList]?.[0]
            updateAndscrollIntoView(version, processVersionList, completedVersionList, "start")
        }).catch((err) => {
            console.error(err)
        }).finally(() => {
            setLoading(false)
        })
    }, [])

    // 搜索
    const [searchText, setSearchText] = useState()
    const [searchTarget, setSearchTarget] = useState("version")
    const handleSearchChangeDebounce = useCallback(_.debounce((value) => {
        const searchText = value.trim()
        setSearchText(searchText)
    }, 500), [searchTarget, processVersionList, completedVersionList])
    const handleSearchChange = useCallback((e) => {
        handleSearchChangeDebounce(e.target.value)
    }, [handleSearchChangeDebounce])
    useEffect(() => {
        if (!initRef.current) return
        if (!searchText) {
            setDisplayProcessVersionList(processVersionList)
            setDisplayCompletedVersionList(completedVersionList)
        } else {
            if (searchTarget === "version") {
                const displayProcessVersionList = processVersionList.filter(item => item.includes(searchText))
                const displayCompletedVersionList = completedVersionList.filter(item => item.includes(searchText))
                const version = [...displayProcessVersionList, ...displayCompletedVersionList]?.[0]
                updateAndscrollIntoView(version, displayProcessVersionList, displayCompletedVersionList)
            } else {
                const params = new URLSearchParams()
                params.append("skuCode", searchText)
                commonApiInvoker(API.merchantversionList(params), false, true).then(res => {
                    const processVersionList = (res || []).filter(item => item.status === 0).map(item => item.deliveryVersion)
                    const completedVersionList = (res || []).filter(item => item.status === 1).map(item => item.deliveryVersion)
                    const version = [...processVersionList, ...completedVersionList]?.[0]
                    updateAndscrollIntoView(version, processVersionList, completedVersionList)
                }).catch((err) => {
                    console.error(err)
                })
            }
        }
    }, [searchText, searchTarget, processVersionList, completedVersionList])

    // 批量下载
    const ref = useRef(null)
    const [messageApi, contextHolder] = message.useMessage()
    const [batchOpen, setBatchOpen] = useState(false)
    const [selectRecords, setSelectRecords] = useState([])
    const [downloadOpen, setDownloadOpen] = useState(false)
    const [downloadTypes, setDownloadTypes] = useState([])
    const [packageType, setPackageType] = useState(0) // 0-按商品分文件下载 1-所有图片合并下载
    const [downloadVersions, setDownloadVersions] = useState([])
    const [downloadSkuIds, setDownloadSkuIds] = useState([])
    const [downloadImageIds, setDownloadImageIds] = useState([])
    const allPassAndSubmitRef = useRef(true)
    const downloadCallbackRef = useRef(null)
    const handleDownload = useCallback((skuIds = [], selectRows = [], callback, imageIds = []) => {
        const targetImages = imageIds.length > 0 ?
            selectRows.flatMap(item => item.deliveryImages || []).filter(imageItem => imageIds.includes(imageItem.imageId)) :
            selectRows.flatMap(item => item.deliveryImages || [])
        // 没有提交通过的图片(不存在【已提交】且【已通过】图片)
        // 存在部分提交通过的图片(不是所有的图片都是【已通过已提交】)
        const allPassAndSubmit = targetImages.length > 0 && targetImages.every(imageItem => {
            return imageItem.status === 2 && !!imageItem.deliverySubmit
        })
        allPassAndSubmitRef.current = allPassAndSubmit
        setDownloadTypes(['origin', 'match', 'delivery'])
        setPackageType(0)
        setDownloadOpen(true)
        setDownloadVersions([versionText])
        setDownloadSkuIds(skuIds)
        setDownloadImageIds(imageIds)
        downloadCallbackRef.current = callback
    }, [versionText])
    const handleBatchDownload = useCallback(() => {
        if (selectRecords.length == 0) {
            message.warning("请先选择要下载的批次")
            return
        }
        setDownloadTypes(['origin', 'match', 'delivery'])
        setPackageType(0)
        setDownloadOpen(true)
        setDownloadVersions(selectRecords)
        setDownloadSkuIds([])
        setDownloadImageIds([])
    }, [selectRecords])
    const handleDownloadOk = useCallback(async () => {
        setDownloadOpen(false)
        const key = new Date().getTime()
        const maxSize = 500 * 1024 * 1024 // 最大分包500M，避免浏览器生成大 Blob 时内存不足
        const openDownloadMessage = (content) => {
            messageApi.open({
                key,
                type: "loading",
                content,
                duration: 0,
            })
        }
        const throttledOpenDownloadMessage = _.throttle(openDownloadMessage, 200, {
            leading: true,
            trailing: true,
        })
        const generateZipBlob = async (targetZip, contentBuilder) => {
            let lastPercent = -1
            try {
                return await targetZip.generateAsync(
                    {
                        type: "blob",
                        // 让 JSZip 以更省内存的方式组织文件内容，降低大包场景下的内存峰值。
                        streamFiles: true,
                    },
                    (metadata) => {
                        const percent = Math.floor(metadata.percent || 0)
                        if (percent !== lastPercent) {
                            lastPercent = percent
                            throttledOpenDownloadMessage(contentBuilder(percent))
                        }
                    }
                )
            } catch (err) {
                if (err?.message?.includes('Array buffer allocation failed')) {
                    throw new Error('压缩包体积过大，浏览器内存不足，请缩小下载范围后重试')
                }
                throw err
            }
        }
        const createProgressHandler = ({ isMultiVersion, versionLabel, sanitizeVersion }) => ({ completed, total, skuCode }) => {
            const prefix = isMultiVersion ? versionLabel : `批次 ${sanitizeVersion}`
            const skuText = skuCode ? `，商品 ${skuCode}` : ''
            throttledOpenDownloadMessage(`正在下载，${prefix}${skuText}（${completed}/${total || 0}）`)
        }
        const createOverflowHandler = ({ zipState, isMultiVersion, versionLabel, sanitizeVersion, versionFolderName }) => async ({ stage, byteLength }) => {
            // beforeWrite: 预计写入后会超阈值时先封包；afterWrite: 对边界值和单文件大图做兜底。
            const shouldFlushBeforeWrite = stage === 'beforeWrite'
                && zipState.currentMemorySize > 0
                && zipState.currentMemorySize + byteLength > maxSize
            const shouldFlushAfterWrite = stage === 'afterWrite' && zipState.currentMemorySize >= maxSize
            if (shouldFlushBeforeWrite || shouldFlushAfterWrite) {
                const content = await generateZipBlob(
                    zipState.current,
                    (percent) => isMultiVersion
                        ? `正在打包，${versionLabel}，分包 ${zipState.partIndex + 1}（${percent}%）`
                        : `正在打包，批次 ${sanitizeVersion}，分包 ${zipState.partIndex + 1}（${percent}%）`
                )
                const filename = isMultiVersion
                    ? `download_${key}（part${zipState.partIndex + 1}）.zip`
                    : `${sanitizeVersion}_${key}（part${zipState.partIndex + 1}）.zip`
                saveAs(content, filename)
                zipState.partIndex += 1
                zipState.current = new JSZip()
                zipState.currentMemorySize = 0
                return isMultiVersion ? zipState.current.folder(versionFolderName) : zipState.current
            }
            if (stage === 'afterWrite') {
                zipState.currentMemorySize += byteLength
            }
            return false
        }
        try {
            openDownloadMessage("正在准备下载")
            const totalPassImages = []
            const zipState = {
                current: new JSZip(),
                currentMemorySize: 0,
                partIndex: 0,
            }
            for (let versionIndex = 0; versionIndex < downloadVersions.length; versionIndex++) {
                const version = downloadVersions[versionIndex]
                const versionLabel = `批次 ${versionIndex + 1}/${downloadVersions.length}`
                openDownloadMessage(`正在准备下载，${versionLabel}`)
                const params = new URLSearchParams()
                params.append('version', version)
                params.append('pageIndex', 1)
                params.append('pageSize', 100)
                if (searchTarget === "skuCode" && searchText) params.append('skuCode', searchText)
                const res = await commonApiInvoker(API.listDeliveryByVersion(params), false, true)
                const total = res.total
                let items = res.items || []
                if (total > 100) {
                    const params = new URLSearchParams()
                    params.append('version', version)
                    params.append('pageIndex', 1)
                    params.append('pageSize', total)
                    if (searchTarget === "skuCode" && searchText) params.append('skuCode', searchText)
                    const res = await commonApiInvoker(API.listDeliveryByVersion(params), false, true)
                    items = res.items || []
                }
                const skuList = items.flatMap(item => item.skuDeliveryList)
                const skuIdList = downloadSkuIds.length > 0 ? downloadSkuIds : skuList.map(item => item.id)
                const images = await commonApiInvoker(API.listPassImages({
                    skuIds: downloadImageIds.length > 0 ? [] : skuIdList,
                    imageIds: downloadImageIds.length > 0 ? downloadImageIds : [],
                    onlyPassed: !downloadWhitelist.includes(globalUser.mobile),
                }), false, true)

                // 过滤出有图片的商品
                if (images.length == 0) continue
                totalPassImages.push(...images)

                const deliveryNamingRule = globalUser.deliveryNamingRule
                const sanitizeVersion = Utils.sanitizeString(version)
                const isMultiVersion = downloadVersions.length > 1
                const progressHandler = createProgressHandler({ isMultiVersion, versionLabel, sanitizeVersion })
                const overflowHandler = createOverflowHandler({
                    zipState,
                    isMultiVersion,
                    versionLabel,
                    sanitizeVersion,
                    versionFolderName: Utils.sanitizeString(version),
                })
                if (downloadVersions.length > 1) {
                    const versionZip = zipState.current.folder(Utils.sanitizeString(version))
                    await downloadAsZip(skuList, images, downloadTypes, packageType, versionZip, deliveryNamingRule, overflowHandler, progressHandler)
                } else {
                    await downloadAsZip(skuList, images, downloadTypes, packageType, zipState.current, deliveryNamingRule, overflowHandler, progressHandler)
                }                
            }
            if (zipState.currentMemorySize > 0) {
                if (downloadVersions.length > 1) {
                    if (zipState.partIndex == 0) {
                        const content = await generateZipBlob(zipState.current, (percent) => `正在打包最终压缩包（${percent}%）`)
                        saveAs(content, `download_${key}.zip`)
                    } else {
                        const content = await generateZipBlob(zipState.current, (percent) => `正在打包最终分包 ${zipState.partIndex + 1}（${percent}%）`)
                        saveAs(content, `download_${key}（part${zipState.partIndex + 1}）.zip`)
                    }
                } else {
                    const sanitizeVersion = Utils.sanitizeString(downloadVersions[0])
                    if (zipState.partIndex == 0) {
                        const content = await generateZipBlob(zipState.current, (percent) => `正在打包批次 ${sanitizeVersion}（${percent}%）`)
                        saveAs(content, `${sanitizeVersion}_${key}.zip`)
                    } else {
                        const content = await generateZipBlob(zipState.current, (percent) => `正在打包批次 ${sanitizeVersion}，分包 ${zipState.partIndex + 1}（${percent}%）`)
                        saveAs(content, `${sanitizeVersion}_${key}（part${zipState.partIndex + 1}）.zip`)
                    }
                }
            }

            if (ref.current) ref.current.updateForce({})
            eventBus.emit('updatePower')
            if (downloadCallbackRef.current) {
                downloadCallbackRef.current()
                downloadCallbackRef.current = null
            }

            if (totalPassImages.length == 0) {
                PSAIModal.info({
                    content: (
                        <div style={{textAlign:"center"}}>
                            仅支持下载已通过且已提交反馈的图片 <br />
                            其余图片请在通过验收后再下载
                        </div>
                    )
                })
                messageApi.destroy(key)
            } else if (!allPassAndSubmitRef.current && !downloadWhitelist.includes(globalUser.mobile)) {
                PSAIModal.info({
                    content: (
                        <div style={{textAlign:"center"}}>
                            仅支持下载已通过且已提交反馈的图片 <br />
                            其余图片请在通过验收后再下载
                        </div>
                    )
                })
                messageApi.destroy(key)
            } else {
                messageApi.success({
                    key,
                    content: "下载成功"
                })
            }
        } catch (err) {
            console.error(err)
            messageApi.open({
                key: key,
                type: 'error',
                content: '下载失败'+err.message,
                duration: 2,
            })
        } finally {
            throttledOpenDownloadMessage.cancel()
        }
    }, [
        searchText, searchTarget, downloadTypes,
        packageType, downloadVersions, downloadSkuIds, downloadImageIds,
        globalUser, messageApi,
    ])
    const handleClick = useCallback((version) => {
        if (batchOpen) {
            setSelectRecords(pre => {
                if (pre.includes(version)) {
                    return pre.filter(item => item !== version)
                } else {
                    return [...pre, version]
                }
            })
        } else {
            setVersionText(version)
            navigate(`/home/homemain/masterDeliver?${new URLSearchParams({version: version}).toString()}`)
        }
    }, [batchOpen])

    // 视图
    const [viewMode, setViewMode] = useState(1)

    return (
        <div className={styles.MasterDelivery}>
            {contextHolder}
            <div className={styles.LeftContainer}>
                <div className={styles.SearchBox}>
                    <Space.Compact>
                        <Select
                            classNames={{
                                root: styles.SearchSelect,
                                popup: {
                                    root: styles.SearchSelectPopup
                                }
                            }}
                            options={[{
                                label: '批次',
                                value: 'version',
                            }, {
                                label: '货号',
                                value: 'skuCode',
                            }]}
                            value={searchTarget}
                            onChange={setSearchTarget}
                        />
                        <Input style={{fontSize: 13}} prefix={<SearchOutlined />} placeholder="搜索" allowClear onChange={handleSearchChange} />
                    </Space.Compact>        
                </div>
                <div className={`${styles.VersionGroup} _beauty_scrollbar`}>
                {
                    (displayProcessVersionList.length > 0 || displayCompletedVersionList.length > 0) ?
                    <>
                    {
                        displayProcessVersionList.length > 0 ?
                        <>
                        <div className={styles.VersionTitle}>进行中</div>
                        <div className={styles.VersionLit}>
                        {displayProcessVersionList.map((item, index) => (
                            <div
                                ref={el => refs1.current[index] = el}
                                key={index}
                                onClick={() => handleClick(item)}
                                className={`${styles.VersionItem} ${versionText === item ? styles.Active : ''} ${batchOpen ? styles.BatchItem : ''} ${batchOpen && selectRecords.includes(item) ? styles.Selected : ''}`}
                            >
                                <span title={item}>{item}</span>
                            </div>
                        ))}
                        </div>
                        </> : null
                    } {
                        displayProcessVersionList.length > 0 && displayCompletedVersionList.length > 0 ?
                        <Divider style={{margin: 0}} /> : null
                    } {
                        displayCompletedVersionList.length > 0 ?
                        <>
                        <div className={styles.VersionTitle}>已完结</div>
                        <div className={styles.VersionLit}>
                        {displayCompletedVersionList.map((item, index) => (
                            <div
                                ref={el => refs2.current[index] = el}
                                key={index}
                                onClick={() => handleClick(item)}
                                className={`${styles.VersionItem} ${versionText === item ? styles.Active : ''} ${batchOpen ? styles.BatchItem : ''} ${batchOpen && selectRecords.includes(item) ? styles.Selected : ''}`}
                            >
                                <span title={item}>{item}</span>
                            </div>
                        ))}
                        </div>
                        </> : null
                    }
                    </> :
                    <div className={styles.Placeholder}>
                    { loading ? <Spin /> : <Empty /> }
                    </div>
                }
                </div>
                <div className={styles.ButtonGroup}>
                {
                    batchOpen ? 
                    <div style={{width:"100%", display:"flex", justifyContent:"center", alignItems:"center", gap: "12px"}}>
                        <Button style={{width: 60}} onClick={() => setBatchOpen(false)}>取消</Button>
                        <Button style={{width: 104}} type="primary" onClick={handleBatchDownload}>下载</Button>
                    </div> :
                    <Button onClick={() => {
                        setBatchOpen(true)
                        setSelectRecords([])
                    }}>批量下载</Button>
                }
                </div>
            </div>
            <div className={styles.RightContainer}>
            {
                versionText ? 
                <DeliveryDetail
                    ref={ref}
                    key={versionText}
                    version={versionText}
                    searchText={searchTarget === "skuCode" ? searchText : ""}
                    onDownload={handleDownload}
                    viewMode={viewMode}
                    onViewModeChange={setViewMode}
                /> :
                <div className={styles.Placeholder}>
                    <Empty description={false} />
                </div>
            }
            </div>
            <PSAIModal
                title="下载"
                width={500}
                maxWidth={"calc(100% - 20px)"}
                open={downloadOpen}
                onOk={handleDownloadOk}
                onCancel={() => setDownloadOpen(false)}
            >
                <div className={styles.DownloadOptions}>
                    <Space size={20}>
                        <span className={styles.OptionLabel}>图片类型</span>
                        <Checkbox.Group
                            value={downloadTypes}
                            options={[
                                { label: '源素材', value: 'origin' },
                                { label: '搭配图', value: 'match' },
                                { label: '参考图', value: 'reference'},
                                { label: '交付图', value: 'delivery'},
                            ]}
                            onChange={setDownloadTypes}
                        />
                    </Space>
                    <Space size={20} style={{alignItems:"flex-start"}}>
                        <span className={styles.OptionLabel}>打包方式</span>
                        <Radio.Group
                            value={packageType}
                            options={[
                                { label: '按商品分文件下载', value: 0 },
                                { label: '所有图片合并下载', value: 1 },
                                { label: '素材图单独文件夹', value: 2 },
                            ]}
                            onChange={e => setPackageType(e.target.value)}
                        />
                    </Space>
                </div>
            </PSAIModal>
        </div>
    )
}
